import { usePostHog } from 'posthog-js/react';
import { useParams } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { useDataContext } from 'src/contexts';

export const useSendAnalyticsEvent = () => {
  const posthog = usePostHog();
  const { hash } = useParams();
  const playwallId = useDataContext((ctx) => ctx.playwallId);
  const identifiedRef = useRef<string | null>(null);

  useEffect(() => {
    if (!posthog || !playwallId || identifiedRef.current === playwallId) return;
    posthog.identify(playwallId);
    identifiedRef.current = playwallId;
  }, [playwallId, posthog]);

  const sendEvent = <T>(eventName: string, params?: T) => {
    posthog?.capture(eventName, {
      ...(params || {}),
      user_id: hash,
      pw_id: playwallId,
    });
  };

  return { sendEvent };
};
